var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex flex-row mb-1 pt-2" },
      [
        _c("b-skeleton", {
          staticClass: "m-2 ml-3",
          attrs: { type: "avatar" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-column ml-4 pt-1 flex-grow-1 pr-3" },
          [
            _c("b-skeleton", { attrs: { animation: "fade", height: "1rem" } }),
            _vm._v(" "),
            _c("b-skeleton", { attrs: { animation: "fade", height: "1rem" } }),
            _vm._v(" "),
            _c("b-skeleton", { attrs: { animation: "fade", height: "1rem" } }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }